<template>
    <div class="simulator">
        <div class="content">
            <div class="simulator_image">
                <SimulatedImage class="simulater_canvas" />
                <Modal />
            </div>
            <ClippingMenu v-if="menu_mode === CONST.MENU_MODE_CLIPPING"/>
            <div class="operation" v-if="menu_mode !== CONST.MENU_MODE_CLIPPING">
                <div class="inside">
                    <div class="btn_wrap">
<!--                        <DefaultMenu v-if="menu_mode === CONST.MENU_MODE_DEFAULT"/>-->
        <!--                <ChangeRoomMenu v-else-if="menu_mode === CONST.MENU_MODE_CHANGE_ROOM"/>-->
                        <button class="menu_button scene" @click="setModal('SelectScene')">
                            <span>シーンを設定&nbsp;・&nbsp;変更</span>
                        </button>
                        <button class="menu_button product" @click="setModal('SelectProducts')" :disabled="editing_progress > 0 && !is_rect_selected || !isCurtain">
                            <span>製品を選ぶ</span>
                        </button>
                        <button class="button_delete slat" @click="setModal(slatSelectCompo)" :disabled="!is_rect_selected">
                            <span>生地・スラットを選ぶ</span>
                        </button>
                        <button class="button_delete parts" @click="setModal('BrowsePartsList')" :disabled="editing_item.disable_parts || parts_list.length === 0 || !is_rect_selected" >
                            <span>部品色を選ぶ</span>
                        </button>
                        <button class="menu_button wall" @click="setModal('SelectWallColor')" :disabled="editing_progress < 0 && isCurtain">
                            <span>壁紙を選ぶ</span>
                        </button>
                    </div>
                    <!-- <button type="button" @click="setItem">Set</button> -->
                    <!-- <nav>
                        <button
                            type="button"
                            :disabled="editing_progress < 2"
                            v-for="feature in ['topBottom', 'frontBack', 'normal', 'weightBar']"
                            @click="setFeature({type: feature})"
                            :key="feature">{{ feature }}</button>
                    </nav> -->
                    <div class="sub_btn" :style="{display: editing_progress < 2 && isCurtain ? 'none' : 'block'}">
                        <DownloadContents/>
                        <SelectMaterialSub :enableSubMaterial="showSubMaterial" />
                    </div>
                </div>
            </div>
        </div>
        <TempFooter/>
    </div>
</template>

<script>
    import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
    import SimulatedImage from '../simulator/SimulatedImage'
    import DefaultMenu from '../menu/DefaultMenu'
    import ChangeRoomMenu from '../menu/ChangeRoomMenu'
    import ClippingMenu from '../menu/ClippingMenu'
    import Modal from "../modal/Modal"
    import CONST from '../../assets/js/const'
    import DownloadContents from '../modal/DownloadContents'
    import SelectMaterialSub from "../modal/SelectMaterialSub";
    import TempFooter from "../template/TempFooter"

    const modalNameClassMap = {
        SelectScene: 'scene',
        SelectProducts: 'product',
        SelectSlatCategory: 'slat',
        BrowseSlatByCtg: 'slat',
        SelectPartsColor: 'parts',
        BrowseTapeColor: 'parts',
        SelectWallColor: 'wall'
    }

    export default {
        name: "Simulator",
        components: {
            TempFooter, SimulatedImage, DefaultMenu, ChangeRoomMenu, ClippingMenu, Modal, DownloadContents, SelectMaterialSub, },
        data: () => ({
            CONST
        }),
        computed: {
            ...mapState(["menu_mode"]),
            ...mapGetters(['modal_name']),
            ...mapState('simulator', ["is_rect_selected"]),
            ...mapGetters('simulator', ["editing_id", "editing_progress", "editing_productType", "editing_prefix", "slat_select_ctg", "parts_list", "editing_item", "feature", "is_slat_selected"]),
            slatSelectCompo () {
                if (this.editing_productType === 'HS-PAIR') {
                    return 'SelectSlatCategory'
                }
                return !['T', 'FT', 'HS'].includes(this.editing_prefix)
                && !this.is_slat_selected
                    ? 'SelectSlatCategory'
                    : 'BrowseSlatByCtg';
            },
            // partsSelectCompo () {
            //     return this.parts_list.length > 0
            //         ? this.parts_list[0].type === 'tape' ? 'BrowseTapeColor' : 'SelectPartsColor'
            //         : ''
            // },
            isSelectSlatOpened: _this => (
                ['SelectSlatCategory', 'BrowseSlatByCtg'].includes(_this.modal_name)
            ),
            isDoubleTexture: _this => {
                if (_this.feature) {
                    const type = _this.feature.type
                    if (['frontBack', 'topBottom'].includes(type)) {
                        return true
                    }
                }
                return false
            },
            showSubMaterial: _this => {
                if (['ZF', 'ZF-FE-PAIR', 'PL-PAIR', 'PL-DOUBLE', 'HS-PAIR', 'LD-PE-100'].includes(_this.editing_productType)) { return true }
                // if (!_this.isDoubleTexture) { return false; }
                return _this.isDoubleTexture ? _this.isSelectSlatOpened : _this.feature?.type !== ''
            },
            isCurtain: _this => _this.editing_item.item_type === CONST.ITEM_TYPE_CURTAIN,
        },
        methods: {
            ...mapActions(['resetTimer']),
            ...mapMutations('simulator', ['createTempItem', 'setFeature']),
            ...mapMutations(['setModal']),
            ...mapActions('simulator', ["updateItemInfo", "commitTempItem"]),
            async addItem() {
                this.createTempItem();
                await this.commitTempItem();
                this.resetTimer();
            }
        },
        watch: {
            modal_name (modal) {
                document.querySelectorAll('.btn_wrap > button').forEach(
                    el => el.classList.remove('active')
                )
                if (modal in modalNameClassMap) {
                    const qlass = modalNameClassMap[modal]
                    const activeTarget = document.querySelector(`[class*=button].${qlass}`)
                    if (activeTarget) {
                        activeTarget.classList.add('active')
                    }
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .simulator{
        overflow: auto;
        .content {
            display: flex;
            margin: 0 calc(12 / 667 * 100%);
            .simulator_image {
                position: relative;
                width: calc(409 / 643 * 100%);
                .simulater_canvas {
                    margin: 0 auto;
                    width: calc(389 / 409 * 100%);
                }
            }
            .operation {
                flex: 1 0 auto;
                margin: 0 calc(10 / 667 * 100%);
                .inside {
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                    .btn_wrap {
                        height: 70%;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        button {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin: 0 auto;
                            text-align: center;
                            border: 1px solid #000;
                            border-radius: 3px;
                            width: 100%;
                            /*max-width: 215px;*/
                            background-color: #fff;
                            padding: 5px 0;
                            font-size: clamp(12px, 1.2vw, 22px);
                            height: calc(20% - 10px);
                            cursor: pointer;
                            transition: 0.3s;
                        }
                        button:hover, button.active {
                            background-color: #000;
                            color: #fff;
                        }
                        button:disabled{
                            cursor: default;
                            pointer-events: none;
                        }
                        @media (max-width: 739px) {
                            button {
                                font-size: 10px;
                                height: calc(20% - 5px);
                            }
                        }
                    }
                    .sub_btn{
                        height: calc(30% - 20px);
                        margin-top: 20px;
                        position: relative;
                    }
                    @media (max-width: 1249px) {
                        .sub_btn{
                            height: calc(30% - 5px);
                            margin-top: 5px;
                        }
                    }
                }
            }
        }
    }
</style>
